/// <reference path="solist.js" />
import React, { Component } from 'react';
import { LineItemSummary } from './LineItemSummary';

export class SOItemList extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        var nametagSOList = this.props.nametagSOList;
        var SOInfo = {};
        for (var i in nametagSOList) {
            if (nametagSOList[i].SOId == this.props.activeSO) {
                SOInfo = nametagSOList[i];
            }
        }
        var missingTranslationsInfo = SOInfo.missingTranslationsInfo;
        var missingTranslationHeaders = Object.keys(missingTranslationsInfo);
        var needsTranslationConfiguration = SOInfo.needsTranslationConfiguration;
        var approveButtonClass = "nametag-approve-button";
        var cancelButtonClass = "nametag-cancel-button";
        if (needsTranslationConfiguration) {
            approveButtonClass += " disabled";
            cancelButtonClass += " disabled";
        }
        return (
            <div className="nametag-so-info">
                <h1>{SOInfo.customerName} - {SOInfo.SONum} - {SOInfo.orderDate}</h1>
                <div className="nametag-app-buttons">
                    <button className={cancelButtonClass} onClick={() => { this.props.returnToSOList(SOInfo.SOId)}}>Mark Unapproved</button>
                    <button className={approveButtonClass} disabled={needsTranslationConfiguration} onClick={() => { this.props.approveSO(SOInfo) }}>Approve</button>
                </div>
                {
                    needsTranslationConfiguration
                    ?
                    <div className="translation-configuration">
                        {
                            missingTranslationHeaders.map(function (header, idx) {
                                return (
                                    <div key={idx}>
                                        <h1>{header}</h1>
                                        {
                                            missingTranslationsInfo[header].map(function (language, idx) {
                                                return (
                                                    <div key={idx}>
                                                        <h3>{language}</h3>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                    :
                    <div className="SO-line-item-info-area">
                        <div className="SO-line-item-info">
                            {
                                //Loop through SOInfo.itemsToApprove and display them
                                SOInfo.itemsToApprove.map(function (item, idx) {
                                    return (
                                        <LineItemSummary
                                            lineItemInfo={item}
                                        />
                                    )
                                })
                            }
                        </div>
                    </div>
                }
            </div>
        );
    }
}